/**
 * Filtro "Filtrar SLA": ordens cuja CALC_PREVISAO cai no dia escolhido e até o horário limite (data + hh:mm).
 */

function toDateOnly(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

function sameCalendarDay(d1, d2) {
  return toDateOnly(d1).getTime() === toDateOnly(d2).getTime();
}

/**
 * @param {Object} order
 * @returns {Date|null}
 */
export function parseOrderCalcPrevisao(order) {
  const raw = order?.CALC_PREVISAO ?? order?.previsao;
  if (raw == null) return null;

  let previsao;
  if (raw instanceof Date) {
    previsao = raw;
  } else if (typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}/.test(raw)) {
    previsao = new Date(raw);
  } else if (typeof raw === 'string') {
    const [datePart, timePart] = raw.trim().split(/\s+/);
    const [d, m, y] = (datePart || '').split('/').map(Number);
    const [h, min] = (timePart || '00:00').split(':').map(Number);
    if (!d || !m || !y) return null;
    previsao = new Date(y, m - 1, d, h || 0, min || 0, 0, 0);
  } else {
    return null;
  }

  if (Number.isNaN(previsao.getTime())) return null;
  return previsao;
}

/**
 * @param {string} dateStr YYYY-MM-DD
 * @param {string} timeStr HH:mm (24h)
 * @returns {number|null} timestamp ms local
 */
export function buildSlaFiltrarDeadlineMs(dateStr, timeStr) {
  if (!dateStr || timeStr == null || String(timeStr).trim() === '') return null;
  const tm = String(timeStr).trim().match(/^(\d{1,2}):(\d{2})(?::\d{2})?/);
  if (!tm) return null;
  const hh = parseInt(tm[1], 10);
  const mm = parseInt(tm[2], 10);
  if (hh < 0 || hh > 23 || mm < 0 || mm > 59 || Number.isNaN(hh) || Number.isNaN(mm)) return null;
  const [y, mo, d] = dateStr.split('-').map(Number);
  if (!y || !mo || !d) return null;
  const deadline = new Date(y, mo - 1, d, hh, mm, 0, 0);
  if (Number.isNaN(deadline.getTime())) return null;
  return deadline.getTime();
}

/**
 * @param {Object} order
 * @param {number} deadlineMs
 */
export function isOrderWithinSlaFiltrarDeadline(order, deadlineMs) {
  const previsao = parseOrderCalcPrevisao(order);
  if (!previsao) return false;
  if (previsao.getTime() > deadlineMs) return false;
  const deadlineDate = new Date(deadlineMs);
  return sameCalendarDay(previsao, deadlineDate);
}
